<template>
    <div>
        <div class="text-center">
            <img src="/img/logo.png" class="standalone-logo" />
            <div class="font-xl mt-2 font-weight-bold text-uppercase lh-sm">Trung tâm Quy hoạch và Điều tra Tài nguyên
                nước quốc gia</div>
        </div>
        <form @submit.prevent="login" class="mt-2">
            <b-input-group class="mb-4">
                <b-input-group-prepend>
                    <b-input-group-text>
                        <i class="icon-user"></i>
                    </b-input-group-text>
                </b-input-group-prepend>
                <input name="username" v-validate="'required'" data-vv-as="Tên đăng nhập" class="form-control"
                    placeholder="Tên đăng nhập" v-model="username" />
                <div v-show="errors.has('username')" class="validation-message text-danger">
                    {{ errors.first('username') }}
                </div>
            </b-input-group>
            <b-input-group class="mb-4">
                <b-input-group-prepend>
                    <b-input-group-text>
                        <i class="icon-lock"></i>
                    </b-input-group-text>
                </b-input-group-prepend>
                <input type="password" class="form-control" :placeholder="$t('loginPage.password')" v-model="password"
                    name="password" v-validate="'required'" :data-vv-as="$t('loginPage.password')" />
                <div v-show="errors.has('password')" class="validation-message text-danger">
                    {{ errors.first('password') }}
                </div>
            </b-input-group>
            <b-button block type="submit" variant="primary" class="px-4 mt-2">{{
                $t('loginPage.login')
                }}</b-button>
        </form>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    name: 'Login',
    data() {
        return {
            username: null,
            password: null
        };
    },
    methods: {
        ...mapActions({
            actionLogin: 'auth/actionLogin',
            getCurrentUserDetail: 'auth/getCurrentUserDetail',
            createAuditByUser: 'user/createAuditByUser'
        }),
        async login() {
            const result = await this.$validator.validateAll();
            if (result) {
                const { username, password } = this;
                await this.actionLogin({ username, password });
                await this.getCurrentUserDetail();
                this.$emit('loginSuccess', true);
                this.createAuditByUser({ content: 'Đăng nhập hệ thống' });
                this.$toaster.success(this.$t('loginPage.loginSuccessMsg'));
            }
        }
    }
};
</script>
